module.exports = __webpack_public_path__ + "img/liucheng4.79208003.png";